/**
 * Dependencies.
 */
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import AddressModel from '@/api/address/address.model';
import { formatAddressSingleLine } from '@/modules/main/utils/address';

/**
 * Component.
 */
@Component({
  name: 'pick-up-info-component'
})
export default class extends Vue {
  /**
   * Property `isScheduleExpanded`.
   */
  isScheduleExpanded = false;

  /**
   * Property `address`.
   */
  @Prop({ type: Object })
  deliveryAddress: AddressModel;

  /**
   * Property `isDelivered`.
   */
  @Prop({ default: false, type: Boolean })
  isDelivered: boolean;

  /**
   * Getter `addressFormatted`.
   */
  get addressFormatted() {
    return formatAddressSingleLine({ address: this.deliveryAddress });
  }

  /**
   * Getter `servicePointName`.
   */
  get servicePointName() {
    const { servicePoint } = this.deliveryAddress || {};
    const { name } = servicePoint || {};

    return name;
  }

  /**
   * Getter `schedule`.
   */
  get schedule() {
    const { servicePoint } = this.deliveryAddress || {};
    const schedule = [];

    const { workDays = null } = servicePoint || {};

    if (workDays) {
      Object.keys(workDays).forEach(day => {
        const {
          afternoonEndTime = null,
          afternoonStartTime = null,
          isActive = false,
          morningEndTime = null,
          morningStartTime = null
        } = workDays[day] || {};

        if (isActive) {
          schedule.push({
            afternoonEndTime: afternoonEndTime
              ? afternoonEndTime.substring(0, 5)
              : null,
            afternoonStartTime: afternoonStartTime
              ? afternoonStartTime.substring(0, 5)
              : null,
            day: Number(day),
            isActive,
            morningEndTime: morningEndTime
              ? morningEndTime.substring(0, 5)
              : null,
            morningStartTime: morningStartTime
              ? morningStartTime.substring(0, 5)
              : null
          });
        }
      });
    }

    return schedule;
  }

  /**
   * Getter `canShowSchedule`.
   */
  get canShowSchedule() {
    const { isDelivered, schedule } = this || {};

    return schedule.length && !isDelivered;
  }

  /**
   * Handle day schedule.
   */
  handleDaySchedule({ day }: { day: number }) {
    const { schedule = [] } = this;

    const dayItem = schedule.find(({ day: itemDay }) => itemDay === day);

    const {
      afternoonEndTime = null,
      afternoonStartTime = null,
      morningEndTime = null,
      morningStartTime = null
    } = dayItem || {};

    const daySchedule =
      morningStartTime &&
      morningEndTime &&
      afternoonStartTime &&
      afternoonEndTime
        ? `${morningStartTime}-${morningEndTime} ${afternoonStartTime}-${afternoonEndTime}`
        : `${morningStartTime || ''}${
          morningStartTime && afternoonEndTime ? `-${afternoonEndTime}` : '-'
        }`;

    return daySchedule;
  }
}
